export const DOMAIN = 'consentConfigDetails.versions';
